export default "__VITE_ASSET__omGwBw0w__"